module.exports = __webpack_public_path__ + "img/Download.a81d38bf.svg";